import { useSelector, shallowEqual } from "react-redux";
import { getBrandDisplayName } from "app/reducers/partnerSelector";
import AuthLayer from "app/pages/Auth/AuthLayer/AuthLayer";

const mapStateToProps = state => {
	return {
		brandDisplayName: getBrandDisplayName(state),
	};
};

const AuthLayerContainer = props => {
	const stateProps = useSelector(mapStateToProps, shallowEqual);
	return <AuthLayer {...props} {...stateProps} />;
};

export default AuthLayerContainer;
